import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { UserService } from 'src/app/services/user-service.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'smart-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css', '../platform-color/platform-color.css']
})
export class CreateUserComponent implements OnInit {
  URLUPLOAD: any = environment.URLUPLOAD;
  option: string;
  userId: string;
  isChecked: boolean = true;
  isAdminChildChecked: boolean = false;
  option_check: any;

  SelectData: any;
  FarmSelectData: any = [];
  AllFarm: any;
  picture: any;
  URLimages = '';
  imageError: string;
  isImageSaved: boolean = false;
  cardImageBase64: string = './assets/img/add-user.png';
  step: any = 1;
  img: any;
  formUser: FormGroup;
  formSendUser: any = [];
  alerterror_Username = false;
  alerterror_Firstname = false;
  alerterror_Lastname = false;
  mySelect;
  org_role: any;
  selectedFarm: any = '';
  selectedPermission: any = '';
  previewImagePath: any;
  authorize: any = [];
  Orgname: any;
  createData: any;
  currentOrg: any;
  currentChildOrg: any;
  response_message: any;
  isAdminChildConfig = false
  oldRole = null
  isDisableToggle = false
  constructor(
    private UserService: UserService,
    private form: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private cdf: ChangeDetectorRef
  ) {
    this.formUser = this.form.group({
      username: new FormControl('', [Validators.required]),
      first_name: new FormControl('', [Validators.required]),
      last_name: new FormControl('', [Validators.required]),
      profile_img: '',
      isActive: '',
      isAdminChild: '',
    });
  }

  ngOnInit(): void {
    // this.option_check = 'edituser'
    this.spinner.show();
    this.option_check = this.route.snapshot.queryParams["option"];
    this.userId = this.route.snapshot.queryParams["userId"];
    console.log("userId : ", this.userId)
    this.currentOrg = sessionStorage.getItem('Org')
    this.currentChildOrg = sessionStorage.getItem('ChildOrg')
    this.getFarmselect();
    if (this.option_check == 'authorize') this.getUserdata(this.userId)
    if (this.option_check == 'edituser') this.getUserFormdata(this.userId);

  }


  getFarmName(farmId) {
    console.log("this.FarmSelectData :", this.FarmSelectData)
    if (this.FarmSelectData) {
      let farm = this.FarmSelectData.farms.filter(x => x.value == farmId)
      return farm[0].name ? farm[0].name : '-'
    };
    return '-'

  }
  getRoleName(role) {
    if (role == 'farm_manager') {
      return 'Farm manager'
    } else if (role == 'worker') {
      return 'Worker'
    } else if (role == 'viewer') {
      return 'Viewer'
    } else {
      return role
    }
  }

  getRoleNameAddPermit(role) {
    if (role == 'Farm manager') {
      return 'farm_manager'
    } else if (role == 'Worker') {
      return 'worker'
    } else if (role == 'Viewer') {
      return 'viewer'
    } else {
      return role
    }
  }

  validateFormUser(form) {
    console.log("form : ", form.username)
    console.log("this.isChecked : ", this.isChecked)
    // check username
    if (form.username == null || form.username == '') {
      this.alerterror_Username = true;
    } else {
      this.alerterror_Username = false;
    }
    // check firstname
    if (form.first_name == null || form.first_name == '') {
      this.alerterror_Firstname = true;
    } else {
      this.alerterror_Firstname = false;
    }
    // check lastname
    if (form.last_name == null || form.last_name == '') {
      this.alerterror_Lastname = true;
    } else {
      this.alerterror_Lastname = false;
    }
    if (!this.alerterror_Username && !this.alerterror_Firstname && !this.alerterror_Lastname) {
      return true
      // this.step = this.step + 1;
      // this.option_check = "edituser"
    } else {
      return false
    }
  }

  createUser() {
    this.formUser.controls["isActive"].setValue(this.isChecked);
    this.formUser.controls["isAdminChild"].setValue(this.isAdminChildChecked ? 'admin_child' : "user");
    let form = this.formUser.value;
    if (this.validateFormUser(form)) {
      const formData = new FormData();
      formData.append('username', form.username);
      formData.append('first_name', form.first_name);
      formData.append('last_name', form.last_name);
      formData.append('active', form.isActive);
      formData.append('auth_role', form.isAdminChild);
      formData.append('profile_img', this.img);
      console.log("create form :", form)
      formData.forEach((value, key) => { //log formData
        console.log(key + " : " + value)//log formData
      });//log formData
      this.spinner.show();
      this.UserService.createUser(formData).subscribe(
        result => {
          // result.code = 409
          // result.message.th = 'ผู้ใช้งานนี้เป็น Admin Child'
          if (result.code == 200) {
            this.spinner.hide();
            this.createData = result.data
            if (form.isAdminChild == 'admin_child') this.adminChildConditionConfig();
            this.option_check = "authorize"
          }
          else if (result.code == 409) {
            this.spinner.hide();
            if (result.message.th == 'สิทธิ์ของฟาร์มคือ admin child ดังนั้นจึงไม่สามารถสร้างฟาร์มสิทธิ์อื่นได้') $('#createFailCaseAdminChild').modal('show');
            else $('#createFailCaseUser').modal('show');
          }
          else {
            this.spinner.hide();
            if (result.message == 'BAD_REQUEST:\"username\" must be in email pattern.') {
              this.response_message = "กรุณากรอกข้อมูลให้ถูกต้อง"
              $('#userFailmodal').modal('show');
            }
            else {
              this.response_message = result.message.th ? result.message.th : "กรุณากรอกข้อมูลให้ถูกต้อง"
              $('#userFailmodal').modal('show');
            }
          }
        }
      )
    }
  }
  previousButton() {
    if (this.step == 1) {
      this.router.navigate(["/manage-user"]);
    }
    if (this.step == 2) {
      this.step = this.step - 1;
    }
  }

  return_Manageuser() {
    this.router.navigate(["/manage-user"]).then(() => {
      window.location.reload();
    });
  }

  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    console.log("fileInput : ,", fileInput)
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      const max_size = 20971520;
      const allowed_types = ['image/png', 'image/jpeg'];
      const max_height = 15200;
      const max_width = 25600;

      if (fileInput.target.files[0].size > max_size) {
        this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Mb';
        return false;
      }
      if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
        this.imageError = 'Only Images are allowed ( JPG | PNG )';
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.spinner.show();
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          console.log(img_height, img_width);
          console.log(e);
          if (img_height > max_height && img_width > max_width) {
            this.imageError =
              'Maximum dimentions allowed ' +
              max_height +
              '*' +
              max_width +
              'px';
            return false;
          } else {
            const imgBase64Path = e.target.result;
            this.cardImageBase64 = imgBase64Path;
            this.isImageSaved = true;
            this.cdf.detectChanges();
          }
        };
        this.spinner.hide();
      };
      reader.readAsDataURL(fileInput.target.files[0]);
      this.img = fileInput.target.files[0];
    }

  }

  onChangeSt() {
    if (this.isChecked == true) {
      this.isChecked = false;
    } else {
      this.isChecked = true;
    }
  }

  onChangeAdminChildSt() {
    if (this.isAdminChildChecked == true) {
      this.isAdminChildChecked = false;
    } else {
      this.isAdminChildChecked = true;
    }
  }


  onChangeAdminSWEdit(value) {
    if (value == 'admin_child') {
      this.formUser.controls["isAdminChild"].setValue('user');
      // this.isChecked = false;
    } else {
      this.formUser.controls["isAdminChild"].setValue('admin_child');
      // this.isChecked = true;
    }
    if (this.option_check == 'edituser' && this.formUser.controls["isAdminChild"].value == 'user') {
      console.log("SHOW MODAL")
      $('#changeRoleModal').modal('show');
    }
  }
  savePrivilege() {
    console.log("Save !");
  }

  async cfChangeRole() {
    console.log("CONF")
  }

  async notCfChangeRole() {
    this.formUser.controls["isAdminChild"].setValue("admin_child");
    console.log("NOT CONF")
  }

  onChangeSWEdit(active) {
    if (active) {
      this.formUser.controls["isActive"].setValue(false);
      // this.isChecked = false;
    } else {
      this.formUser.controls["isActive"].setValue(true);
      // this.isChecked = true;
    }
  }

  openFileUpload() {
    $("#chooseFile").trigger("click")
  }

  openFileUploadEdit() {
    $("#chooseFileEdit").trigger("click")
  }

  ///////////////////////// add authorize /////////////////////

  async getFarmselect() {
    let AllFarmselect = [];
    let farms = [];
    this.spinner.show();
    await this.UserService.getFarmselect(this.currentOrg)
      .subscribe(success => {
        console.log("getFarmselect OK", success);
        if (success.code == 200) {
          this.AllFarm = success.data;
          this.Orgname = success.data[0].org_name
          for (let i = 0; i < this.AllFarm.length; i++) {
            for (let j = 0; j < this.AllFarm[i].farms.length; j++) {
              farms.push({
                name: this.AllFarm[i].farms[j].farm_name,
                value: this.AllFarm[i].farms[j].farm_id,
              })
            }
            AllFarmselect.push({
              child_org_id: this.AllFarm[i].child_org_id,
              child_org_name: this.AllFarm[i].child_org_name,
              farms: farms,
            })
          }
          this.FarmSelectData = AllFarmselect[0];
          console.log("getFarmselect show: ", this.FarmSelectData);
          console.log("getFarmselect show: ", this.Orgname);
          this.spinner.hide();
        }
      });
  }

  addPermissionArr(farmId, role) {
    // this.authorize.filter()
    if (farmId == "" || role == "") {
      $('#addempty').modal('show');
    } else {
      let farm = this.authorize.filter(x => x._id == farmId)
      console.log("farm : ", farm)
      if (farm.length == 0) {
        this.authorize.push({
          _id: farmId,
          role: this.getRoleName(role),
          name: this.getFarmName(farmId)
        })
      } else {
        $('#duplicateFarm').modal('show');
      }
      this.selectedFarm = ""
      this.selectedPermission = ""
    }
    console.log("this.authorize : ", this.authorize)

  }

  adminChildConditionConfig() {
    this.isAdminChildConfig = true
    this.addPermissionAdminChild()
  }

  addPermissionAdminChild() {
    for (let i in this.FarmSelectData.farms) {
      this.authorize.push({
        _id: this.FarmSelectData.farms[i].value,
        role: this.getRoleName('farm_manager'),
        name: this.getFarmName(this.FarmSelectData.farms[i].value)
      })
    }
  }

  removePermissionArr(farmId) {
    this.authorize = this.authorize.filter(function (obj) {
      return obj._id !== farmId;
    });
  }

  async savePermission() {
    console.log("createData : ", this.createData)
    const farms = []

    console.log(this.authorize)

    for (let i = 0; i < this.authorize.length; i++) {
      console.log(this.authorize[i]._id)
      farms.push({
        _id: this.authorize[i]._id,
        role: this.getRoleNameAddPermit(this.authorize[i].role)
      })
    }

    let data = {
      currentOrg: this.currentOrg,
      currentChildOrg: this.currentChildOrg,
      userid: this.createData ? this.createData._id : this.userId,
      farm_authorize: farms
    }
    console.log(data.farm_authorize)

    // for (let i = 0 ; i < data.farm_authorize.length ; i++) {
    //   data.farm_authorize[i].role = this.getRoleNameAddPermit(farms[i].role)
    // }



    await this.UserService.updateFarmAuthorize(data)
      .subscribe(success => {
        console.log("udpateFarnAuthorize success : ", success)
        if (success.code == 200) {
          $('#addAuthSuccessmodal').modal('show');
        } else {
          $('#addAuthFailmodal').modal('show');
        }
      });
  }

  ////// edit ///////

  async getUserFormdata(id) {
    await this.UserService.getUserByid(id)
      .subscribe(async (success) => {
        if (success.code == 200) {
          let userinfo = success.data;
          this.formUser.controls["username"].setValue(userinfo.username);
          this.formUser.controls["first_name"].setValue(userinfo.first_name);
          this.formUser.controls["last_name"].setValue(userinfo.last_name);
          this.formUser.controls["profile_img"].setValue(userinfo.profile_img);
          this.formUser.controls["isAdminChild"].setValue(userinfo.system_role);
          this.oldRole = userinfo.system_role
          if (this.oldRole == 'admin_child') this.isDisableToggle = true
          else this.isDisableToggle = false
          console.log(this.isDisableToggle)
          let currentOrg = this.currentOrg
          let currentChildOrg = this.currentChildOrg
          let active = true
          await userinfo.authorized.filter(async function (value) {
            if (value.org_id == currentOrg) {
              await value.child_orgs.filter(async function (value2) {
                if (value2.child_org_id == currentChildOrg) {
                  active = value2.active;
                }
              });
            }
          });
          this.formUser.controls["isActive"].setValue(active);
          // $('#addAuthSuccessmodal').modal('show');
          this.spinner.hide()
        } else {
          // $('#addAuthFailmodal').modal('show');
          this.spinner.hide()
        }
        console.log("this.formUser", this.formUser)
      });

  }

  async getUserdata(id) {
    let currentOrg = this.currentOrg
    let currentChildOrg = this.currentChildOrg
    let authorizedFarms = []
    this.spinner.show()
    await this.getFarmselect()
    await this.UserService.getUserByid(id)
      .subscribe(async (success) => {
        if (success.code == 200) {
          let userinfo = success.data;
          if (userinfo.system_role == 'admin_child') {
            this.isAdminChildConfig = true
            for (const i in this.FarmSelectData.farms) {
              authorizedFarms.push({
                _id: this.FarmSelectData.farms[i].value,
                role: 'farm_manager',
              })
            }
          }
          else {
            console.log("DADSDASDA")
            this.isAdminChildConfig = false
            await userinfo.authorized.filter(async function (value) {
              if (value.org_id == currentOrg) {
                if (value.child_orgs.length !== 0) {
                  await value.child_orgs.filter(async function (value2) {
                    if (value2.child_org_id == currentChildOrg) {
                      if (value2.farms.length !== 0) {
                        for (let i = 0; i < value2.farms.length; i++) {
                          const element = value2.farms[i];
                          authorizedFarms.push({
                            _id: element.farm_id,
                            role: element.role
                          })
                        }
                      } else {
                        //err
                      }
                    } else {
                      //err
                    }
                  });

                } else {
                  //err
                }
              }
            });
          }
          this.createFarmPermiss(authorizedFarms)
          // this.authorize = authorized;
          this.spinner.hide()
          console.log("authorize.authorize : ", this.authorize)
        } else {
          this.spinner.hide()
        }
      });
  }

  async createFarmPermiss(farms = []) {
    console.log("createFarmPermiss WORK")
    console.log(farms)
    let completedFarm = []
    if (this.FarmSelectData) {
      for (let i = 0; i < farms.length; i++) {
        let farm = this.FarmSelectData.farms.find(x => x.value == farms[i]._id)
        if (farm) {
          completedFarm.push({
            _id: farms[i]._id,
            role: this.getRoleName(farms[i].role),
            name: farm.name
          })
        }
      }
    };
    this.authorize = completedFarm;
  }

  async checkRoleCondition() {
    let form = this.formUser.value;
    // const isEditUser = await this.editUserWithConditon()
    // console.log("=====================")
    // console.log(isEditUser)
    // if(!isEditUser) return
    let authorizedFarms = []
    console.log("=====================")
    console.log(form.isAdminChild)
    if (this.oldRole == form.isAdminChild) {
      console.log("NOT CHANGE")
      if (form.isAdminChild == 'admin_child') {
        for (const i in this.FarmSelectData.farms) {
          authorizedFarms.push({
            _id: this.FarmSelectData.farms[i].value,
            role: 'farm_manager',
          })
        }
        this.createFarmPermiss(authorizedFarms)
        this.isAdminChildConfig = true
        this.option_check = 'authorize'
      }
      else {
        this.isAdminChildConfig = false
        this.option_check = 'authorize'
        await this.getUserdata(this.userId)
      }

    }
    else {
      console.log("CHANGE")
      ///// Delete All Farms
      this.authorize = []
      let resCode
      let data = {
        currentOrg: this.currentOrg,
        currentChildOrg: this.currentChildOrg,
        userid: this.createData ? this.createData._id : this.userId,
        farm_authorize: this.authorize,
      }
       await this.UserService.updateFarmAuthorize(data)
        .subscribe(async success => {
          console.log("udpateFarnAuthorize success : ", success)
          if (success.code == 200) {
            if (form.isAdminChild == 'admin_child') {
              for (const i in this.FarmSelectData.farms) {
                authorizedFarms.push({
                  _id: this.FarmSelectData.farms[i].value,
                  role: 'farm_manager'
                })
              }
              await this.createFarmPermiss(authorizedFarms)
              this.isAdminChildConfig = true
              this.option_check = 'authorize'
              this.cdf.detectChanges();
            
            }
            else {
              this.isAdminChildConfig = false
              this.option_check = 'authorize'
              this.cdf.detectChanges();
             
            }


          } else {
          }
        });

        // this.option_check = 'authorize'

    }
  }

  async editUser() {
    // this.formUser.controls["isActive"].setValue(this.isChecked);
    let form = this.formUser.value;
    console.log("form : ", form)
    if (this.validateFormUser(form)) {
      const formData = new FormData();
      formData.append('username', form.username);
      formData.append('first_name', form.first_name);
      formData.append('last_name', form.last_name);
      formData.append('active', form.isActive);
      formData.append('auth_role', form.isAdminChild);
      formData.append('profile_img', this.img);
      console.log("create form :", form)
      formData.forEach((value, key) => { //log formData
        console.log(key + " : " + value)//log formData
      });//log formData
      this.spinner.show();
      await this.UserService.updateUser(formData).subscribe(
        result => {
          console.log("updateUser result : ", result)
          if (result.code == 200) {
            this.response_message = result.message.th ? result.message.th : "กรุณากรอกข้อมูลให้ถูกต้อง"

          }

          else {
            this.response_message = result.message.th ? result.message.th : "กรุณากรอกข้อมูลให้ถูกต้อง"
            $('#userFailmodal').modal('show');
          }
          this.spinner.hide();
        }
      )
    }
  }

  async editUserWithConditon() {
    // this.formUser.controls["isActive"].setValue(this.isChecked);
    let form = this.formUser.value;
    console.log("form : ", form)
    if (this.validateFormUser(form)) {
      const formData = new FormData();
      formData.append('username', form.username);
      formData.append('first_name', form.first_name);
      formData.append('last_name', form.last_name);
      formData.append('active', form.isActive);
      formData.append('auth_role', form.isAdminChild);
      formData.append('profile_img', this.img);
      console.log("create form :", form)
      formData.forEach((value, key) => { //log formData
        console.log(key + " : " + value)//log formData
      });//log formData
      this.spinner.show();
      await this.UserService.updateUser(formData).subscribe(
        result => {
          console.log("updateUser result : ", result)
          if (result.code == 200) {
            this.response_message = result.message.th ? result.message.th : "กรุณากรอกข้อมูลให้ถูกต้อง"
            this.spinner.hide();
            this.checkRoleCondition()

          }
          else if (result.code == 409) {
            this.spinner.hide();
            $('#editFailCaseUser').modal('show');
          }

          else {
            this.response_message = result.message.th ? result.message.th : "กรุณากรอกข้อมูลให้ถูกต้อง"
            this.spinner.hide();
            $('#userFailmodal').modal('show');

          }
        }
      )
    }
  }

  openAuthDetail() {
    $('#userInfomodal').modal('show');
  }

  openAdminChildetail() {
    $('#adminChildInfomodal').modal('show');
  }
}
